import HAIR_THICKNESS from '../../assets/scalp/sample/HAIR_THICKNESS.png';
import HAIR_QUANTITY from '../../assets/scalp/sample/HAIR_QUANTITY.png';
import HAIR_FOLLICLE_DENSITY from '../../assets/scalp/sample/HAIR_FOLLICLE_DENSITY.png';
import HAIR_PER_HAIR_FOLLICLE from '../../assets/scalp/sample/HAIR_PER_HAIR_FOLLICLE.png';

export const hairlossProgressRecentData = {
  id: 1,
  rediagnoseRecommended: true,
  diagnosisDate: '2022-07-12T15:22:23.457Z',
  hairlossProgress: 73,
  hairlossAverage: 45,
  diagnosisItems: [
    {
      type: 'HAIR_FOLLICLE_DENSITY',
      normal: {
        image: HAIR_FOLLICLE_DENSITY,
        value: 22,
      },
      hairloss: {
        image: HAIR_FOLLICLE_DENSITY,
        value: 5,
      },
    },
    {
      type: 'HAIR_QUANTITY',
      normal: {
        image: HAIR_QUANTITY,
        value: 22,
      },
      hairloss: {
        image: HAIR_QUANTITY,
        value: 35,
      },
    },
    {
      type: 'HAIR_PER_HAIR_FOLLICLE',
      normal: {
        image: HAIR_PER_HAIR_FOLLICLE,
        value: 1.35,
      },
      hairloss: {
        image: HAIR_PER_HAIR_FOLLICLE,
        value: 1.2,
      },
    },
    {
      type: 'HAIR_THICKNESS',
      normal: {
        image: HAIR_THICKNESS,
        value: 0.25,
      },
      hairloss: {
        image: HAIR_THICKNESS,
        value: 0.2,
      },
    },
  ],
};
